import React from "react";
import styled from "styled-components";

export const IconDiv = styled.div`
  width: 19.52px;
  height: 4px;
  background: linear-gradient(110.86deg, #57048a 9.46%, #4822cf 89.64%);
  border-radius: 2px;
  margin: 21px 0 30px 0;
  transition: all 0.85s;
`;

const Icon = () => {
  return <IconDiv />;
};

export default Icon;
